// routes/UserRoutes.jsx

import { Routes, Route, Navigate } from 'react-router-dom';

// ── Role listing pages ─────────────────────────────────────────────────────
import UserRolePage      from '../pages/users/UserRolePage';
import AllUsersPage      from '../pages/users/AllUsersPage';

// ── Hierarchy ──────────────────────────────────────────────────────────────
import UserHierarchyPage from '../pages/users/UserHierarchyPage';

// ── Special ────────────────────────────────────────────────────────────────
import {
  AddUserPage,
  BulkImportPage,
  UserPermissionsPage,
  UserRolesPage,
} from '../pages/users/AddUserPage';

// ── Meta ───────────────────────────────────────────────────────────────────
import ActivityLogsPage from '../pages/users/ActivityLogsPage';
import UserReportsPage from '../pages/users/UserReportsPage'
import CommissionStructurePage from '../pages/users/CommissionStructurePage'
import InactiveUsersPage from '../pages/users/InactiveUsersPage';
import ActiveUsersPage from '../pages/users/ActiveUsersPage';
import ClientsPage from '../pages/users/ClientsPage';
import RetailersPage from '../pages/users/RetailersPage';
import SubDistributorsPage from '../pages/users/SubDistributorsPage';
import DistributorsPage from '../pages/users/DistributorsPage';
import SuperDistributorsPage from '../pages/users/SuperDistributorsPage';
import AdminsPage from '../pages/users/AdminsPage';
const UserRoutes = () => (
  <Routes>
    {/* Default → all */}
    <Route index element={<Navigate to="all" replace />} />

    {/* ── Role Listings ─────────────────────────────────────── */}
    <Route path="all"                element={<UserRolePage />} />
    <Route path="admins"             element={<AdminsPage />} />
    <Route path="super-distributors" element={<SuperDistributorsPage />} />
    <Route path="distributors"       element={<DistributorsPage />} />
    <Route path="subdistributors"    element={<SubDistributorsPage />} />
    <Route path="retailers"          element={<RetailersPage />} />
    <Route path="clients"            element={<ClientsPage />} />
    <Route path="active"             element={<ActiveUsersPage />} />
    <Route path="inactive"           element={<InactiveUsersPage />} />

    {/* ── Hierarchy ─────────────────────────────────────────── */}
    <Route path="hierarchy"          element={<UserHierarchyPage />} />

    {/* ── Special ───────────────────────────────────────────── */}
    <Route path="add"                element={<AddUserPage />} />
    <Route path="bulk-import"        element={<BulkImportPage />} />
    <Route path="permissions"        element={<UserPermissionsPage />} />
    <Route path="roles"              element={<UserRolesPage />} />

    {/* ── Meta ──────────────────────────────────────────────── */}
    <Route path="activity-logs"      element={<ActivityLogsPage />} />
    <Route path="commission"         element={<CommissionStructurePage />} />
    <Route path="reports"            element={<UserReportsPage />} />

    {/* Fallback */}
    <Route path="*" element={<Navigate to="all" replace />} />
  </Routes>
);

export default UserRoutes;